/**
 * 言語設定の actions
 */
const actions = {

  /**
   * 言語設定をセットします
   */
  lang: ({ commit }, payload) => {
    commit('lang', payload);
  }

};

export { actions as default };
